export default function setCssVariable(
  name: string,
  value: string | number,
  unit?: string | null,
  element: HTMLElement = document.documentElement
): void {
  const fullValue = unit != null ? `${value}${unit}` : String(value);
  element.style.setProperty(name, fullValue);
}
